import { ca } from '@cian/analytics';

import { TPublicWebV1SearchResponse_MlRanking } from '../../common/repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { mlSearchSession } from '../../common/utils/mlSearchSession';
import { ITrackOfferActionsProps } from '../types';

export function trackOfferCardShow(
  { offerPosition, offerId, jsonQuery, pageNumber, offersLength, queryString }: ITrackOfferActionsProps,
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined,
) {
  ca('teaser', {
    sc: jsonQuery,
    product: {
      screen: 'Listing',
      block: 'Listing_snippet',
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position: offerPosition,
    },
    page: {
      listingType: 'list',
      pageType: 'Listing',
      offersQty: offersLength,
      pageNumber,
      extra: {
        mobileWebsiteType: 'new',
        mlSearchSessionGuid: mlSearchSession.getSessionGuid(jsonQuery),
        mlRankingGuid: mlRanking?.guid,
        mlRankingModelVersion: mlRanking?.modelVersion,
      },
      siteType: 'mobile',
      queryString,
    },
  });
}
